import React from 'react';
import { Container } from 'react-bootstrap';

const Footer = ({ texts }) => {
    return (
        <footer className="bg-dark text-white py-4">
            <Container className="text-center">
                <p>
                    <a href={`https://${texts.links.websiteLink}`} target="_blank" rel="noopener noreferrer" className="text-white">
                        {texts.footer.company}
                    </a>
                </p>
                <p>{texts.footer.address}</p>
            </Container>
        </footer>
    );
};

export default Footer;